module.exports = __webpack_public_path__ + "img/1 (110).08ddc0ba.png";